import { Injector, NgZone } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangePasswordComponent } from '../views/account/components/modals/change-password/change-password.component';
import { ModalUtils } from '../utils/modal-utils';

export class ModalChangePassword {
  static open(ngZone: NgZone, ngbModal: NgbModal, injector: Injector) {
    ngZone.run(() => {
      const modalRef = ngbModal.open(ChangePasswordComponent, ModalUtils.defaultModalOptions(injector));
      modalRef.result.then(_ => {});
    });
  }
}
